import {
  CHANGE_CURRENT_SCREEN,
  STORE_NIUM_FOREX_USER,
  STORE_TRANSACTION_ID,
  STORE_SELECTED_BENE_ID,
  STORE_TRANSACTION_DETAILS,
  STORE_IS_PAN_VERIFIED,
  STORE_IS_PAN_NAME_VERIFIED,
  STORE_RE_VERIFY_AADHAR_FLAG,
  STORE_CAF_DOCUMENT_CHANGED_FLAG,
  STORE_NIUM_FOREX_USER_DETAILS,
  STORE_NF_CROSS_SELL_INFORMATION,
  STORE_IS_REFERRED
} from '../../action-contants';
import { API_URL } from '../../../utils/config';
import { handleError } from '../common-message/message-action';
import { makeApiCall } from '../common/common-action';

import {
  IStoreTransactionDetails,
  ISendMoneyPayload,
  IAadharVerificationPayload,
  IuploadDocuments,
  IVideoKycPayload
} from '../../../screens/nium-forex/utils/interface';

const changeScreenAction = (data: string) => {
  return {
    type: CHANGE_CURRENT_SCREEN,
    data
  };
};

export const changeNiumForexScreen = (screenName: string) => {
  return (dispatch: (data: any) => void): any => {
    dispatch(changeScreenAction(screenName));
  };
};

const storeNiumForexUserAction = (data: boolean) => {
  return {
    type: STORE_NIUM_FOREX_USER,
    data
  };
};

const storeTransactionDetailsAction = (data: IStoreTransactionDetails) => {
  return {
    type: STORE_TRANSACTION_DETAILS,
    data
  };
};

export const storeNiumForexUser = (data: boolean) => {
  return (dispatch: (data: any) => void): void => {
    dispatch(storeNiumForexUserAction(data));
  };
};

const storeNiumForexUserDetailsAction = (data: Record<string, any>) => {
  return {
    type: STORE_NIUM_FOREX_USER_DETAILS,
    data
  };
};

export const storeNiumForexUserDetails = (data: Record<string, any>) => {
  return (dispatch: (data: any) => void): void => {
    dispatch(storeNiumForexUserDetailsAction(data));
  };
};

export const getNiumForexUserDetails = () => {
  return async (dispatch: (data: any) => void): Promise<void> => {
    try {
      const response = await makeApiCall({
        url: `${API_URL}/niumForex/remitter/details`,
        method: 'get',
        withCredentials: true
      });
      if (response?.data?.success) {
        if (response.data?.data?.remitterDetails)
          dispatch(storeNiumForexUserDetails(response.data.data.remitterDetails));
      }
    } catch (error) {
      dispatch(handleError(error));
    }
  };
};

export function getNiumForexDocumentsUploadList(temp_transaction_id: number) {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      return await makeApiCall({
        url: `${API_URL}/niumForex/transaction/document-list`,
        withCredentials: true,
        method: 'get',
        params: { temp_transaction_id: temp_transaction_id }
      });
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export const submitNiumForexDocumentsUploadList = (data: IuploadDocuments | any) => {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const payload = new FormData();
      Object.keys(data)?.map((key) => payload.append(key, data[key]));
      const response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/niumForex/transaction/document-upload`,
        data: payload,
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response;
    } catch (error: any) {
      dispatch(handleError(error));
      return error?.response?.data ?? { success: false };
    }
  };
};

const storeSelectedBeneAction = (data: number) => {
  return {
    type: STORE_SELECTED_BENE_ID,
    data
  };
};

export const storeSelectedBeneId = (data: number) => {
  return (dispatch: (data: any) => void): void => {
    dispatch(storeSelectedBeneAction(data));
  };
};

const storeReVerifyAadhar = (data: boolean) => {
  return {
    type: STORE_RE_VERIFY_AADHAR_FLAG,
    data
  };
};

export const storeReverifyAadharFlag = (data: boolean) => {
  return (dispatch: (data: any) => void): void => {
    dispatch(storeReVerifyAadhar(data));
  };
};

const storeCafDocumentFlag = (data: boolean) => {
  return {
    type: STORE_CAF_DOCUMENT_CHANGED_FLAG,
    data
  };
};

export const storeCafDocumentChanged = (data: boolean) => {
  return (dispatch: (data: any) => void): void => {
    dispatch(storeCafDocumentFlag(data));
  };
};

export const addRemitterBankDetails = (
  transactionId: number,
  formData: { [key: string]: string }
) => {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const data = {
        notes: formData['note'],
        remitter_bank_id: formData['bankId'],
        remitter_account_number: formData['accNumber'],
        remitter_bank_name: formData['bankName'],
        is_bank_info_update: true
      };
      // @ts-ignore
      if (!data.notes || !data.notes.length) delete data.notes;
      const res = await makeApiCall({
        method: 'patch',
        url: `${API_URL}/niumForex/transaction/${transactionId}`,
        withCredentials: true,
        data
      });
      return res;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
};

export const storeTransactionDetails = (data: IStoreTransactionDetails) => {
  return (dispatch: (data: Record<string, any>) => void): void => {
    dispatch(storeTransactionDetailsAction(data));
  };
};

export async function niumForexTransactionComputation(
  params: Record<string, any>,
  config: any = {}
): Promise<any> {
  try {
    const response = await makeApiCall({
      method: 'get',
      url: `${API_URL}/niumForex/transaction/computed-value`,
      withCredentials: true,
      params
    });
    return response?.data?.data;
  } catch (error) {
    if (config?.failSilently) {
      throw error;
    }
    // @ts-ignore
    const message: string = error?.response?.data?.data?.message;
    if (message) {
      return message;
    } else {
      throw error;
    }
  }
}

export const createNiumForexTempTransaction = (
  payload: ISendMoneyPayload,
  selectedReasonForTransferCode: string
) => {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        url: `${API_URL}/niumForex/temp-transaction/initiate`,
        method: 'post',
        data: payload,
        withCredentials: true
      });
      if (response?.data?.success) {
        const transactionDetails: IStoreTransactionDetails = {
          sourceAmount: payload?.gross_source_amount,
          sourceCurrency: payload?.source_currency,
          destinationCurrency: payload?.destination_currency,
          destinationAmount: payload?.destination_amount,
          tempTransactionId: response?.data?.temp_transaction_id,
          sourceOfFunds: payload?.source_of_funds,
          reasonForTransfer: payload?.reason_for_transfer,
          remittanceType: payload?.remittance_type,
          remittanceTypeCode: payload?.remittance_type_code,
          selectedReasonForTransferCode: selectedReasonForTransferCode,
          transactionId: null
        };
        dispatch(storeTransactionDetails(transactionDetails));
      }
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
    return { success: false };
  };
};

export const storeTransactionIdAction = (data: number): { type: string; data: any } => {
  return {
    type: STORE_TRANSACTION_ID,
    data
  };
};

export const initiateNiumForexTransaction = (tempTransactionId: number) => {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        url: `${API_URL}/niumForex/transaction/initiate/${tempTransactionId}`,
        method: 'post',
        withCredentials: true
      });
      const transactionId = response?.data?.data?.transaction_id;
      if (!transactionId) {
        return { success: false };
      }
      dispatch(storeTransactionIdAction(transactionId));
      return { success: true };
    } catch (error) {
      dispatch(handleError(error));
    }
    return { success: false };
  };
};
export function getCaptureLink(data: IAadharVerificationPayload) {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/niumForex/aadhar/initiate`,
        data,
        withCredentials: true
      });
      return { success: true, ...response?.data?.data };
    } catch (exception) {
      dispatch(handleError(exception));
    }
    return { success: false };
  };
}

export function getUserAadharStatus(params: IAadharVerificationPayload) {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/niumForex/aadhar/status/${params?.tempTransactionId}`,
        withCredentials: true
        // params
      });
      return { success: true, ...response?.data?.data };
    } catch (exception) {
      dispatch(handleError(exception));
    }
    return { success: false };
  };
}

export function getVideoKycCaptureLink(data: IVideoKycPayload) {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        method: 'post',
        url: API_URL + '/niumForex/video-kyc/initiate',
        data,
        withCredentials: true
      });
      return { success: true, ...response?.data?.data };
    } catch (exception) {
      dispatch(handleError(exception));
    }
    return { success: false };
  };
}

export function getUserVideoKycStatus(id: number) {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/niumForex/video-kyc/status/${id}`,
        withCredentials: true
      });
      return { success: true, ...response?.data?.data };
    } catch (exception) {
      dispatch(handleError(exception));
    }
    return { success: false };
  };
}
export function getPendingTransaction(): any {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/niumForex/transaction/history?is_pending_transaction=true`,
        withCredentials: true
      });

      return { success: true, ...response?.data };
    } catch (exception) {
      dispatch(handleError(exception));
    }
    return { success: false };
  };
}

export const getNiumForexTransactionDetails = (transactionId: string) => {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        url: `${API_URL}/niumForex/transaction/details/${transactionId}`,
        method: 'get',
        withCredentials: true
      });
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
};

export const getNiumForexPayInBanks = (countryCode: string, currencyCode: string) => {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        url: `${API_URL}/niumForex/payin-bank/list?countryCode=${countryCode}&currencyCode=${currencyCode}`,
        method: 'get',
        withCredentials: true
      });
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
};

const storeIsPanVerifiedAction = (data: boolean) => {
  return {
    type: STORE_IS_PAN_VERIFIED,
    data
  };
};

export const storeIsPanVerified = (isPanVerified: boolean) => {
  return (dispatch: (data: any) => void): void => {
    dispatch(storeIsPanVerifiedAction(isPanVerified));
  };
};

const storeIsPanNameVerifiedAction = (data: boolean) => {
  return {
    type: STORE_IS_PAN_NAME_VERIFIED,
    data
  };
};

const storeIsReferredAction = (data: boolean) => {
  return {
    type: STORE_IS_REFERRED,
    data
  };
};

export const storeIsPanNameVerified = (isPanNameVerified: boolean) => {
  return (dispatch: (data: any) => void): void => {
    dispatch(storeIsPanNameVerifiedAction(isPanNameVerified));
  };
};

export const storeIsReferred = (isReferral: boolean) => {
  return (dispatch: (data: any) => void): void => {
    dispatch(storeIsReferredAction(isReferral));
  };
};

export function getSourceOfFunds() {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/niumForex/instarem-object/dropdown?type=SOURCE_OF_FUNDS&account_type=INDIVIDUAL`,
        withCredentials: true
      });
      return { success: true, ...response?.data };
    } catch (exception) {
      dispatch(handleError(exception));
    }
    return { success: false };
  };
}

export function getReasonForTransfer() {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/niumForex/instarem-object/dropdown?type=REASON_FOR_TRANSFER&account_type=INDIVIDUAL`,
        withCredentials: true
      });
      return { success: true, ...response?.data };
    } catch (exception) {
      dispatch(handleError(exception));
    }
    return { success: false };
  };
}

export function getStudentOptions() {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/niumForex/instarem-object/dropdown?type=REMITTANCE_TYPE&account_type=INDIVIDUAL`,
        withCredentials: true
      });
      return { success: true, ...response?.data };
    } catch (exception) {
      dispatch(handleError(exception));
    }
    return { success: false };
  };
}

export const authoriseForexTransaction = (
  data: Record<string, any>,
  transactionId: number | undefined
) => {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        method: 'patch',
        data,
        url: `${API_URL}/niumForex/transaction/${transactionId}`,
        withCredentials: true
      });
      return response?.data;
    } catch (exception) {
      dispatch(handleError(exception));
    }
    return { success: false };
  };
};

export const setCrossSellingInformationAction = (data: { [key: string]: any }) => {
  return {
    type: STORE_NF_CROSS_SELL_INFORMATION,
    data
  };
};

export const registerCrossSellingInterest = (data: any) => {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/niumForex/remitter/forex-interest`,
        withCredentials: true,
        data
      });
      return response.data;
    } catch (exception) {
      dispatch(handleError(exception));
    }
    return { success: false };
  };
};
